export default __webpack_public_path__ + "static/apple-icon-180x180-ae54af4b052f238ed5de4d6e53de290b.png";